import { Component, Host, h } from '@stencil/core';
import '../../assets/chatScript.js';

@Component({
  tag: 'legrandav-chat-component',
  styleUrl: 'legrandav-chat-component.css',
  shadow: true,
})
export class LegrandavChatComponent {
  render() {
    return (
      <Host>
        <div></div>
      </Host>
    );
  }
}
